import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Typography, Icon } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type IBroadcastAssigneeTypes } from 'entities/Broadcast/api/types'
import { type IBroadcastAssigneeCustomItem } from '../../store/types'

import styles from './styles.module.scss'

export type ICustomItemProps = {
  item: IBroadcastAssigneeCustomItem
  active: boolean
  onClose: () => void
  onReassign: (id: IBroadcastAssigneeTypes) => void
}

export const CustomItem: FC<ICustomItemProps> = observer(
  ({ item, active, onClose, onReassign }) => {
    const handleReassign = async (id: IBroadcastAssigneeTypes) => {
      if (active) return

      onClose()
      onReassign(id)
    }

    return (
      <div
        className={classnames(styles.memberWrapper, {
          [styles.active]: active,
        })}
        aria-label={getAriaLabel(item.type)}
        onClick={() => handleReassign(item.id)}
      >
        <div className={classnames(styles.info)}>
          <Icon icon={item.icon} color='var(--content-primary-tertiary)' />
          <Typography
            className={styles.memberName}
            variant='body-md-regular'
            color='var(--content-primary-primary)'
            pointer
            ellipsis
            ariaLabel={'name'}
          >
            {item.label}
          </Typography>
        </div>
        {active && <Icon icon='check1' color='var(--content-brand-primary)' />}
      </div>
    )
  }
)
